// MAIN NAV: Open submenu on hover

$(document).ready(function() {
    function updateHover() {
        if ($(window).width() >= 960) {
            $('a[data-parent]').on('mouseenter', function() {
                $(this).next('ul').stop(true, true).fadeIn(300);
                $('.navigation__submenu').not($(this).next('ul')).stop(true, true).fadeOut(300);
            });
            $(document).on('click', function(e) {
                if (!$(e.target).closest('.navigation__submenu').length && !$(e.target).is('a[data-parent]')) {
                    $('.navigation__submenu').stop(true, true).fadeOut(300);
                }
            });
        } else {
            $('a[data-parent]').off('mouseenter');
            $(document).off('click');
        }
    }

    $(window).resize(updateHover);
    updateHover();
});
